export const carSlug = name => String(name || 'rental-car').replace(/^\d{4}\s+/, '').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'') || 'rental-car';
export const carPath = (id,name) => `/car/${id}/${carSlug(name)}`;
